import clsx from 'clsx'

type PaginationItemProps = {
  pageNumber: number
  /** @default false */
  isCurrent?: boolean
  onPageChange: (pageNumber: number) => void
}

export const PaginationItem = ({
  pageNumber,
  isCurrent = false,
  onPageChange
}: PaginationItemProps) => {
  return (
    <button
      className={clsx(
        'flex   items-center justify-center px-[10px] text-xs font-normal h-8 rounded-lg',
        {
          'bg-secondary-dark text-white': isCurrent,
          'bg-grey-50 text-grey-900': !isCurrent,
        }
      )}
      onClick={() => onPageChange(pageNumber)}
    >
      {pageNumber}
    </button>
  )
}
